import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import FetchDocuments from '@/pages/FetchDocuments';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function FetchDocsPage({ token, user }) {
  const navigate = useNavigate();

  const handleDocumentsAdded = () => {
    // Redirect to documents page with hash to scroll to API section
    setTimeout(() => {
      navigate('/dashboard/documents#api');
    }, 2000);
  };

  return (
    <DashboardLayout user={user} token={token}>
      <div className="container mx-auto px-4 py-4 sm:py-6 w-full min-w-0">
        <FetchDocuments token={token} onDocumentsAdded={handleDocumentsAdded} />
      </div>
    </DashboardLayout>
  );
}
